export default function getArticleVersion({ state, articleID, exhibitionID = state.currentExhibitionID }) {
	const exhibition = state.dataSourceCFG && state.dataSourceCFG.exhibitionMap[exhibitionID];

	if (!exhibition) return;
	const articles = exhibition.articles.find((article) => article[0] === articleID);
	return articles && articles[1].version;
}
